<div class="generic-modal row" tabindex="0">
  <div class="col-12 auto-center">
    @if (showIcon) {
      <img class="img-alert" src="assets/img/ok.png" alt="icon ok" />
    }
    <p
      class="info-text modal-text"
      [innerHtml]="message | translate: { euribor: euribor, insurance: insurance, boeEuribor: boeEuribor }"
    ></p>
  </div>

  <div class="col-12 modal-btn-group">
    @if (txtButtonCancel) {
      <button id="modal-generic-cancel" class="btn btn-01 btn-modal" type="submit" (click)="cancel()" id="btn-accept">
        {{ txtButtonCancel | translate }}
      </button>
    }
    <button id="modal-generic-confirm" class="btn btn-02 btn-modal" type="submit" (click)="accept()" id="btn-accept">
      {{ txtButton | translate }}
    </button>
  </div>
</div>
